import { useLocation } from "@/compat/react-router-dom";
import HttpErrorContent from "./HttpErrorContent";

export default function NotFoundPage() {
  const location = useLocation();
  return (
    <HttpErrorContent
      code={404}
      requestedPath={location.pathname + (location.search || "")}
    />
  );
}
